// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1n-hS","footer":"ModalError_footer__3Ezrs"};